// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const NotificationTypes = {
  EventNotifications: "event_notifications",
  SystemAnnouncements: "system_announcements",
  ProcessUpdates: "process_updates",
} as const;
export type NotificationTypes = (typeof NotificationTypes)[keyof typeof NotificationTypes];

export function instanceOfNotificationTypes(value: any): boolean {
  for (const key in NotificationTypes) {
    if (Object.prototype.hasOwnProperty.call(NotificationTypes, key)) {
      if (NotificationTypes[key as keyof typeof NotificationTypes] === value) {
        return true;
      }
    }
  }
  return false;
}

export function NotificationTypesFromJSON(json: any): NotificationTypes {
  return NotificationTypesFromJSONTyped(json, false);
}

export function NotificationTypesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): NotificationTypes {
  return json as NotificationTypes;
}

export function NotificationTypesToJSON(value?: NotificationTypes | null): any {
  return value as any;
}

export function NotificationTypesToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): NotificationTypes {
  return value as NotificationTypes;
}
